import React, { useEffect, useState } from "react";
import { BrowserRouter, useParams, useSearchParams} from 'react-router-dom';
//import Navbar from "react-bootstrap/Navbar";
import {Container, Nav, Navbar, NavDropdown} from "react-bootstrap";

import { PageLayout } from "./components/PageLayout";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useIsAuthenticated} from "@azure/msal-react";
import { loginRequest, GetAccessToken, SetAccessToken } from "./authConfig";
import { useMsal } from "@azure/msal-react";
import { fetchUserMe, fetchDirectory, FolderData, FolderDataFileEntry } from "./graph";
import { User, DriveItem} from "@microsoft/microsoft-graph-types";

import { SignInButton } from "./components/SignInButton";
import { DirectoryList, ViewMode} from "./components/DirectoryList";
import { SignOutButton } from "./components/SignOutButton";

function DirectoryBrowser(props:{browserParams : URLSearchParams}) : JSX.Element {
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();
const [userProfileData, setUserProfileData] = useState<User>();
const [viewMode, setViewMode] = useState<ViewMode>('large');

  var pathName = props.browserParams.get('path');

  useEffect(() => {
    const authRequestParams = {
      ...loginRequest,
      account: accounts[0],
    };
    instance.acquireTokenSilent(authRequestParams).then(async (response) => {
      SetAccessToken(response.accessToken);
      var profile = await fetchUserMe();
      setUserProfileData(profile);
    });
  }, [props.browserParams]);

  if (!userProfileData) {
    return <div>Requesting profile data</div>;
  }

  const onClickHandlerForSize = (viewSize:ViewMode) => () => {
    setViewMode(viewSize);
  }

  return (
    <>
    <Navbar bg="primary" variant="dark">
      <Container>
        <Navbar.Brand href='#'>{userProfileData.givenName} : {pathName}</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#home">Dummy link</Nav.Link>
            <NavDropdown title="View" id="basic-nav-dropdown">
              <NavDropdown.Item onClick={onClickHandlerForSize('small')}>Small Images</NavDropdown.Item>
              <NavDropdown.Item onClick={onClickHandlerForSize('medium')}>Medium Images</NavDropdown.Item>
              <NavDropdown.Item onClick={onClickHandlerForSize('large')}>Large Images</NavDropdown.Item>
              <NavDropdown.Item onClick={onClickHandlerForSize('table')}>Table</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">This doesn't do anything</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
        { isAuthenticated ? <SignOutButton /> : <SignInButton /> }

      </Container>
    </Navbar>

    <DirectoryList pathName={pathName} viewMode={viewMode}/>
    </>
  );
}

function MainApp() : JSX.Element {
  const [browserParams] = useSearchParams();
  return (
    <DirectoryBrowser browserParams={browserParams}/>
  )
}

function App() : JSX.Element{
  return (
    <BrowserRouter>
        <AuthenticatedTemplate>
          <MainApp />
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <SignInButton />
        </UnauthenticatedTemplate>
    </BrowserRouter>
  );
}

export default App;
